import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

/* ================= PUBLIC PAGES ================= */
import AboutUs from "./components/AboutUs";
import OurClients from "./components/OurClients";
import CareersPage from "./components/CareersPage";
import JobDetailsPage from "./components/JobDetailsPage";
import ApplyPage from "./components/ApplyPage";
import AISolutions from "./Learnmore/AISolutions";

import RDPage from "./components/RDPage";
import UIUXPage from "./components/UIUXPage";
import CloudServicesPage from "./components/CloudServicesPage";
import EdgeComputingPage from "./components/EdgeComputingPage";
import AutonomousNavigationPage from "./components/AutonomousNavigationPage";
import IoTIntegrationPage from "./components/IoTIntegrationPage";
import ObjectDetectionPage from "./components/ObjectDetectionPage";

import NewsroomPage from "./components/NewsroomPage";
import Hero from "./components/Hero";
import Carousel from "./components/Carousel";
import ServicesGrid from "./components/ServicesGrid";
import CalloutSection from "./components/CalloutSection";
import VideoCard from "./components/VideoCard";
import Homepages from "./components/Homepages";
import BlogPage from "./components/BlogPage";
import HelpCenterPage from "./components/HelpCenter";
import ApiDocsPage from "./components/ApiDocs";
import PrivacyPolicyPage from "./components/PrivacyPolicy";
import TermsOfServicePage from "./components/TermsOfService";
import SecurityPage from "./components/Security";
import FraudAlertPage from "./components/FraudAlertPage";
import FraudAlertTicketPage from "./components/FraudAlertTicketPage";
import ValidateOfferPage from "./components/ValidateOfferPage";
import LetterToShareholdersPage from "./components/LetterToShareholdersPage";
import LetterToShareholdersDetailPage from "./components/LetterToShareholdersDetailPage";

/* Payroll */
import PayrollPage from "./components/PayrollPages/Payroll";
import PayrollProcessing from "./components/PayrollPages/PayrollProcessing";
import PayrollSoftware from "./components/PayrollPages/PayrollSoftware";

/* HR Services */
import HRInsightsPage from "./components/HRservices/HRInsightsPage";
import HRServicesPage from "./components/HRservices/HRServicesPage";
import PartnerIntegrationPage from "./components/HRservices/PartnerIntegrationPage";
import HRServiceDetailPage from "./components/HRservices/HRServiceDetailPage";

/* Health Services */
import HealthServicePage from "./components/HealthServices/HealthServicePage";

/* ================= SERVICES (DETAILED) ================= */
import DataScienceAI from "./components/OurServices/DataScienceAI";
import ObjectDetection from "./components/OurServices/ObjectDetection";
import EdgeComputing from "./components/OurServices/EdgeComputing";
import IoTIntegration from "./components/OurServices/IoTIntegration";
import CloudSecurity from "./components/OurServices/CloudSecurity";
import DataVisualization from "./components/OurServices/DataVisualization";
import UIUXDesign from "./components/OurServices/UIUXDesign";
import MobileDevelopment from "./components/OurServices/MobileDevelopment";
import AIMLServices from "./components/OurServices/AIMLServices";
import DataScience from "./components/OurServices/DataScience";
import OurServicesIndex from "./components/OurServices/OurServicesIndex";

/* ================= AUTH ================= */
import { AuthProvider } from "./context/AuthContext";

/* ================= LAYOUTS ================= */
import PublicLayout from "./components/Admins/PublicLayout";
import AdminLayout from "./components/Admins/AdminLayout";
import HRAdminLayout from "./components/HRadmin/HRAdminLayout";
import HRDashboardPage from "./components/HRAdminpages/HRDashboardPage";
import HRJobManagementPage from "./components/HRAdminpages/HRJobManagementPage";
import HRApplicationManagementPage from "./components/HRAdminpages/HRApplicationManagementPage";
import HRInterviewSchedulingPage from "./components/HRAdminpages/HRInterviewSchedulingPage";
import HRReleasingOfferLetterPage from "./components/HRAdminpages/HRReleasingOfferLetterPage";
import HRUploadOfferLetterPage from "./components/HRAdminpages/HRUploadOfferLetterPage";
import HRExportingDataPage from "./components/HRAdminpages/HRExportingDataPage";
import HRProfilePage from "./components/HRAdminpages/HRProfilePage";
import HREmployeeDetailsPage from "./components/HRAdminpages/HREmployeeDetailsPage";
import HRBulkEmailsPage from "./components/HRAdminpages/HRBulkEmailsPage";
import HREmployeeCredentialsPage from "./components/HRAdminpages/HREmployeeCredentialsPage";
import ContentManagerLayout from "./components/ContentManager/ContentManagerLayout";
import CandidateDashboard from "./components/Candidate/CandidateDashboard";
import Chatbot from "./components/Chatbot";

/* ================= AdminPages ================= */
import Dashboard from "./pages/Dashboard";
import RoleManagement from "./pages/RoleManagement";
import BlogManagement from "./pages/BlogManagement";
import JobManagement from "./pages/JobManagement";
import ApplicationManagement from "./pages/ApplicationManagement";
import InterviewScheduling from "./pages/InterviewScheduling";
import OurClientsManagement from "./pages/OurClientsManagement";

import ProtectedRoute from "./routes/ProtectedRoute";

import Candidatecareer from "./components/Candidate/Candidatecareer.js";
import CandidateJobDetailsPage from "./components/Candidate/candidatejobdetails";

import BlogPost from "./pages/BlogPost";
import AdminImages from "./pages/AdminImages";

import AllPosts from "./pages/AllPosts";

import ExportingData from "./pages/ExportingData";
import AdminProfile from "./pages/AdminProfile";
import EditInfo from "./pages/EditInfo";
import PasswordChange from "./pages/PasswordChange";
import ShareholderLettersManagement from "./pages/ShareholderLettersManagement";

import ContentManagerDashboard from "./components/ContentManagerPages/Dashboard.js";
import ContentManagerBlogPosts from "./components/ContentManagerPages/BlogPosts.js";
import ContentManagerImages from "./components/ContentManagerPages/Images.js";
import ContentManagerBlogForm from "./components/ContentManagerPages/BlogForm.js";
import ContentManagerBlogDetails from "./components/ContentManagerPages/BlogDetails.js";
import SEO from "./components/seo/SEO";
import { buildServiceSchema } from "./components/seo/serviceSchema";
import { SERVICE_ROUTES } from "./constants/serviceRoutes";
import { notifyWebsiteVisit } from "./services/visitorService";

const createSeoElement = (
  element,
  { title, description, canonicalPath, schema }
) => (
  <>
    <SEO
      title={title}
      description={description}
      canonical={
        canonicalPath
          ? new URL(canonicalPath, "https://blackroth.in").toString()
          : undefined
      }
      schema={schema}
    />
    {element}
  </>
);

const notFoundElement = (
  <>
    <SEO
      title="Page Not Found | BlackRoth"
      description="The requested BlackRoth page could not be found."
      canonical="https://blackroth.in/404"
      robots="noindex,follow"
    />
    <main style={{ minHeight: "60vh", padding: "120px 24px", textAlign: "center" }}>
      <h1>Page not found</h1>
      <p>The page you are looking for does not exist.</p>
    </main>
  </>
);

const createServiceSeo = (title, description, canonicalPath, serviceName) => ({
  title,
  description,
  canonicalPath,
  schema: buildServiceSchema({
    name: serviceName,
    description,
    path: canonicalPath,
  }),
});

const COOKIE_NOTICE_NAME = "blackroth_cookie_preference";
const COOKIE_NOTICE_MAX_AGE = 60 * 60 * 24 * 180;

const hasCookiePreference = () =>
  Boolean(getCookiePreference());

const getCookiePreference = () => {
  const cookie = document.cookie
    .split("; ")
    .find((item) => item.startsWith(`${COOKIE_NOTICE_NAME}=`));

  if (!cookie) {
    return "";
  }

  return decodeURIComponent(cookie.split("=").slice(1).join("="));
};

const saveCookiePreference = (preference) => {
  document.cookie = `${COOKIE_NOTICE_NAME}=${preference}; max-age=${COOKIE_NOTICE_MAX_AGE}; path=/; SameSite=Lax`;
};

const VISIT_NOTIFICATION_KEY = "blackroth_visit_notification_sent";

const INTERNAL_PATH_PREFIXES = [
  "/components/Admins",
  "/HRadmin",
  "/ContentManager",
  "/candidate",
  "/Candidate",
  "/layout",
];

const shouldNotifyWebsiteVisit = () => {
  const currentPath = window.location.pathname;

  return !INTERNAL_PATH_PREFIXES.some((prefix) =>
    currentPath.startsWith(prefix)
  );
};

const allowsVisitNotification = (preference = getCookiePreference()) =>
  preference === "accepted" ||
  (preference.startsWith("custom-") && preference.includes("analytics"));

const sendWebsiteVisitNotification = () => {
  if (!shouldNotifyWebsiteVisit() || !allowsVisitNotification()) {
    return;
  }

  if (localStorage.getItem(VISIT_NOTIFICATION_KEY)) {
    return;
  }

  localStorage.setItem(VISIT_NOTIFICATION_KEY, "true");

  notifyWebsiteVisit({
    pageUrl: window.location.href,
    pageTitle: document.title,
    referrer: document.referrer,
    language: navigator.language,
    screen: `${window.screen?.width || ""}x${window.screen?.height || ""}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    visitedAt: new Date().toISOString(),
  }).catch((error) => {
    localStorage.removeItem(VISIT_NOTIFICATION_KEY);
    console.error("Website visit notification failed:", error);
  });
};

const pageSeo = {
  home: {
    title: "BlackRoth | Software Development Company Hyderabad | Web Development & Cybersecurity",
    description:
      "BlackRoth is a trusted software development company in Hyderabad offering web development, mobile app development, cybersecurity, AI/ML, cloud security, and IT solutions.",
    canonicalPath: "/",
  },
  aboutUs: {
    title: "About Us | BlackRoth Company, Mission & Technology",
    description:
      "Learn about BlackRoth, our mission, values, and expertise in building secure, scalable, future-ready technology solutions for modern businesses.",
    canonicalPath: "/about-us",
  },
  contact: {
    title: "Contact BlackRoth | Software Development Company Hyderabad",
    description:
      "Contact BlackRoth to discuss software development, AI, cybersecurity, cloud, HR, payroll, and digital service needs.",
    canonicalPath: "/contact-us",
  },
  ourClients: {
    title: "Our Clients | BlackRoth",
    description:
      "Explore BlackRoth client work across accessibility, computer vision, healthcare operations, and global delivery regions.",
    canonicalPath: "/our-clients",
  },
  careers: {
    title: "Careers at BlackRoth | Jobs & Internships",
    description:
      "Explore careers, jobs, and internship opportunities at BlackRoth and join our team to build intelligent, secure, and future-ready digital solutions.",
    canonicalPath: "/careers",
  },
  careerDetails: {
    title: "Career Opportunity at BlackRoth | Job Details",
    description:
      "Review responsibilities, qualifications, and application details for current BlackRoth career opportunities and open roles.",
  },
  newsroom: {
    title: "Newsroom | BlackRoth News & Updates",
    description:
      "Explore BlackRoth announcements, company updates, and stories about our technology, innovation, and business milestones.",
    canonicalPath: "/newsroom",
  },
  blog: {
    title: "Blog | BlackRoth Insights & Articles",
    description:
      "Read BlackRoth articles on software development, AI, cybersecurity, cloud solutions, and digital innovation.",
    canonicalPath: "/newsroom/blog",
  },
  help: {
    title: "Help Center | BlackRoth Support & FAQs",
    description:
      "Find answers, support guidance, and helpful information about BlackRoth services, workflows, and common questions.",
    canonicalPath: "/help",
  },
  apiDocs: {
    title: "API Docs | BlackRoth Developer Documentation",
    description:
      "Explore BlackRoth API documentation, integration references, and developer guidance for connected applications.",
    canonicalPath: "/apidocs",
  },
  privacy: {
    title: "Privacy Policy | BlackRoth",
    description:
      "Read how BlackRoth collects, uses, stores, and protects personal information across our website and services.",
    canonicalPath: "/privacy",
  },
  terms: {
    title: "Terms of Service | BlackRoth",
    description:
      "Review the terms, conditions, responsibilities, and usage rules that apply to BlackRoth services and website access.",
    canonicalPath: "/terms",
  },
  security: {
    title: "Security | BlackRoth Platform & Data Security",
    description:
      "Learn how BlackRoth approaches platform security, data protection, responsible practices, and operational safeguards.",
    canonicalPath: "/security",
  },
  fraudAlert: {
    title: "Fraud Alert | BlackRoth Official Recruitment Notice",
    description:
      "Read BlackRoth's official recruitment fraud alert to identify fake job offers, scam emails, and suspicious hiring communications.",
    canonicalPath: "/fraud-alert",
  },
  fraudTicket: {
    title: "Report Recruitment Fraud | BlackRoth Fraud Alert Ticket",
    description:
      "Submit a recruitment fraud report to BlackRoth and share suspicious job offers, emails, or communications for review.",
    canonicalPath: "/raise-fraud-alert-ticket",
  },
  validateOffer: {
    title: "Validate Offer Letter | BlackRoth",
    description:
      "Verify BlackRoth offer letters securely and confirm recruitment communications through the official validation page.",
    canonicalPath: "/validate-and-accept-offer",
  },
  shareholders: {
    title: "Letter to Shareholders | BlackRoth",
    description:
      "Read BlackRoth leadership updates, company perspective, and long-term vision in the latest letter to shareholders.",
    canonicalPath: "/letter-to-shareholders",
  },
  shareholderDetail: {
    title: "Letter to Shareholders | BlackRoth",
    description:
      "Read the selected BlackRoth shareholder letter and explore company updates, leadership perspective, and future direction.",
  },
  rd: {
    title: "Research & Development | BlackRoth",
    description:
      "Discover BlackRoth research and development capabilities focused on innovation, experimentation, and future-ready technology solutions.",
    canonicalPath: "/research-and-development",
  },
  uiux: {
    title: "UI/UX Design Services | BlackRoth",
    description:
      "Explore BlackRoth UI/UX design services for intuitive interfaces, better product experiences, and user-centered digital journeys.",
    canonicalPath: "/ui-ux-design-services",
  },
  cloudServices: {
    title: "Cloud Services | BlackRoth",
    description:
      "Learn about BlackRoth cloud services for scalable infrastructure, migration, modernization, and secure cloud operations.",
    canonicalPath: "/cloud-services",
  },
  cyberSecurity: {
    title: "Cyber Security Services | BlackRoth",
    description:
      "Explore BlackRoth cybersecurity services for risk reduction, protection, monitoring, and resilient digital operations.",
    canonicalPath: "/cyber-security",
  },
  objectDetection: {
    title: "Object Detection & Tracking | BlackRoth",
    description:
      "See how BlackRoth builds object detection and tracking solutions using computer vision for intelligent real-time systems.",
    canonicalPath: "/object-detection",
  },
  autonomousNavigation: {
    title: "Autonomous Navigation | BlackRoth",
    description:
      "Discover BlackRoth autonomous navigation solutions for robotics, intelligent movement, and real-time decision systems.",
    canonicalPath: "/autonomous-navigation",
  },
  edgeComputing: {
    title: "Edge Computing | BlackRoth",
    description:
      "Explore BlackRoth edge computing solutions for low-latency processing, connected devices, and intelligent distributed systems.",
    canonicalPath: "/edge-computing",
  },
  iotIntegration: {
    title: "IoT Integration | BlackRoth",
    description:
      "Learn how BlackRoth integrates IoT systems, sensors, and connected devices into secure, scalable digital ecosystems.",
    canonicalPath: "/iot-integration",
  },
  dataScienceAI: createServiceSeo(
    "Data Science with AI | BlackRoth",
    "Explore BlackRoth data science with AI services for predictive insights, automation, and smarter business decisions.",
    SERVICE_ROUTES.dataScienceAi,
    "Data Science with AI"
  ),
  objectDetectionService: createServiceSeo(
    "Object Detection Services | BlackRoth",
    "Discover BlackRoth object detection services for computer vision workflows, tracking, and intelligent automation.",
    SERVICE_ROUTES.objectDetection,
    "Object Detection Services"
  ),
  edgeComputingService: createServiceSeo(
    "Edge Computing Services | BlackRoth",
    "Explore BlackRoth edge computing services for faster processing, connected devices, and real-time intelligence.",
    SERVICE_ROUTES.edgeComputing,
    "Edge Computing Services"
  ),
  iotIntegrationService: createServiceSeo(
    "IoT Integration Services | BlackRoth",
    "Learn how BlackRoth IoT integration services connect devices, systems, and data into efficient digital operations.",
    SERVICE_ROUTES.iotIntegration,
    "IoT Integration Services"
  ),
  cyberSecurityService: createServiceSeo(
    "Cyber Security Services | BlackRoth",
    "Explore BlackRoth cyber security services for protection, monitoring, resilience, and secure business continuity.",
    SERVICE_ROUTES.cyberSecurity,
    "Cyber Security Services"
  ),
  cloudSecurityService: createServiceSeo(
    "Cloud Security Services | BlackRoth",
    "Discover BlackRoth cloud security services for safer cloud environments, governance, and infrastructure protection.",
    SERVICE_ROUTES.cloudSecurity,
    "Cloud Security Services"
  ),
  dataVisualizationService: createServiceSeo(
    "Data Visualization Services | BlackRoth",
    "Turn complex information into clear dashboards and visual stories with BlackRoth data visualization services.",
    SERVICE_ROUTES.dataVisualization,
    "Data Visualization Services"
  ),
  uiuxDesignService: createServiceSeo(
    "UI/UX Design Services | BlackRoth",
    "Build intuitive and engaging product experiences with BlackRoth UI/UX design services for digital platforms.",
    SERVICE_ROUTES.uiUxDesign,
    "UI/UX Design Services"
  ),
  mobileDevelopmentService: createServiceSeo(
    "Mobile Development Services | BlackRoth",
    "Explore BlackRoth mobile development services for high-performance apps, seamless experiences, and scalable delivery.",
    SERVICE_ROUTES.mobileDevelopment,
    "Mobile Development Services"
  ),
  aimlServices: createServiceSeo(
    "AI & ML Services | BlackRoth",
    "Discover BlackRoth AI and machine learning services for intelligent automation, prediction, and business innovation.",
    SERVICE_ROUTES.aiMlServices,
    "AI & ML Services"
  ),
  dataScienceService: createServiceSeo(
    "Data Science Services | BlackRoth",
    "Use BlackRoth data science services to uncover insights, improve decisions, and create measurable business value.",
    SERVICE_ROUTES.dataScience,
    "Data Science Services"
  ),
  ourServicesIndex: createServiceSeo(
    "Our Services | BlackRoth",
    "Explore BlackRoth service offerings and navigate to AI, data, security, cloud, design, and mobile solutions.",
    SERVICE_ROUTES.index,
    "Technology and Business Services"
  ),
  hrServicesIndex: createServiceSeo(
    "HR Services | BlackRoth",
    "Explore BlackRoth HR services including people operations, outsourcing support, and workforce process solutions.",
    SERVICE_ROUTES.hrIndex,
    "HR Services"
  ),
  payrollIndex: createServiceSeo(
    "Payroll Services | BlackRoth",
    "Explore BlackRoth payroll solutions including payroll services, payroll processing, and payroll software support.",
    SERVICE_ROUTES.payrollIndex,
    "Payroll Services"
  ),
  aiSolutions: {
    title: "AI Solutions | BlackRoth",
    description:
      "Discover BlackRoth AI solutions spanning intelligent assistants, predictive systems, automation, and modern AI applications.",
    canonicalPath: "/ai-solutions",
  },
  aiSolutionsAlias: {
    title: "AI Solutions | BlackRoth",
    description:
      "Discover BlackRoth AI solutions spanning intelligent assistants, predictive systems, automation, and modern AI applications.",
    canonicalPath: "/ai-solutions",
  },
  payroll: createServiceSeo(
    "Payroll Services | BlackRoth",
    "Explore BlackRoth payroll services for accurate salary workflows, compliance support, and efficient workforce operations.",
    SERVICE_ROUTES.payrollServices,
    "Payroll Services"
  ),
  payrollProcessing: createServiceSeo(
    "Payroll Processing Services | BlackRoth",
    "Learn about BlackRoth payroll processing services for timely payouts, compliance workflows, and dependable payroll management.",
    SERVICE_ROUTES.payrollProcessing,
    "Payroll Processing"
  ),
  payrollSoftware: createServiceSeo(
    "Payroll Software | BlackRoth",
    "Discover BlackRoth payroll software designed to simplify payroll operations, records, and workforce administration.",
    SERVICE_ROUTES.payrollSoftware,
    "Payroll Software"
  ),
  hrInsights: createServiceSeo(
    "HR Insights | BlackRoth",
    "Read BlackRoth HR insights on workforce strategy, people operations, and modern organizational improvement.",
    SERVICE_ROUTES.hrInsights,
    "HR Insights"
  ),
  hrServices: createServiceSeo(
    "HR Services | BlackRoth",
    "Explore BlackRoth HR services for people operations, workforce processes, and business-ready HR support.",
    SERVICE_ROUTES.hrServices,
    "HR Services"
  ),
  partnerIntegration: createServiceSeo(
    "Partner Integration | BlackRoth",
    "See how BlackRoth partner integration services connect external platforms, workflows, and business systems seamlessly.",
    SERVICE_ROUTES.partnerIntegration,
    "Partner Integration"
  ),
};

function App() {
  const [heroTitle, setHeroTitle] = useState("");
  const [showCookieNotice, setShowCookieNotice] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const [showCookieClassification, setShowCookieClassification] =
    useState(false);
  const [activeCookieCategory, setActiveCookieCategory] = useState("privacy");
  const [cookieSettings, setCookieSettings] = useState({
    analytics: true,
    personalization: true,
    marketing: false,
  });

  const homePageContent = (
    <>
      <Hero heroTitle={heroTitle} showHeroTitle={false} />
      <Carousel />
      <CalloutSection />
      <ServicesGrid />
      <VideoCard />
      <Homepages />
    </>
  );

  useEffect(() => {
    const text = "AI Fuel. The Future Engine.";
    let index = 0;
    const step = 2;
    const speed = 200;

    function typeEffect() {
      if (index < text.length) {
        setHeroTitle(text.substring(0, index + step));
        index += step;
        setTimeout(typeEffect, speed);
      }
    }

    typeEffect();
  }, []);

  useEffect(() => {
    setShowCookieNotice(!hasCookiePreference());
    sendWebsiteVisitNotification();
  }, []);

  const handleCookiePreference = (preference) => {
    saveCookiePreference(preference);
    setShowCookieNotice(false);
    setShowCookieSettings(false);
    setShowCookieClassification(false);

    if (allowsVisitNotification(preference)) {
      sendWebsiteVisitNotification();
    }
  };

  const handleCookieSettingsSave = () => {
    const selectedSettings = [
      "essential",
      cookieSettings.analytics ? "analytics" : null,
      cookieSettings.personalization ? "personalization" : null,
      cookieSettings.marketing ? "marketing" : null,
    ]
      .filter(Boolean)
      .join("-");

    handleCookiePreference(`custom-${selectedSettings}`);
  };

  const cookiePreferenceCategories = [
    {
      key: "privacy",
      label: "Your Privacy",
      title: "Your Privacy",
      description:
        "BlackRoth uses cookies to keep the website reliable, understand how visitors use our pages, and make your experience more relevant. You can review each category and choose which optional cookies you want to allow.",
      locked: true,
    },
    {
      key: "essential",
      label: "Strictly Necessary Cookies",
      title: "Strictly Necessary Cookies",
      description:
        "These cookies are required for core website features such as page navigation, secure areas, form handling, and remembering your consent choice. They cannot be switched off from this preference centre.",
      locked: true,
    },
    {
      key: "analytics",
      label: "Performance Cookies",
      title: "Performance Cookies",
      description:
        "These cookies help BlackRoth measure traffic, page performance, and common visitor paths so we can improve content, loading behavior, and the overall website experience.",
      enabled: cookieSettings.analytics,
      settingKey: "analytics",
    },
    {
      key: "personalization",
      label: "Functional Cookies",
      title: "Functional Cookies",
      description:
        "These cookies help remember choices such as preferred content behavior and visitor preferences, making repeat visits smoother and more relevant.",
      enabled: cookieSettings.personalization,
      settingKey: "personalization",
    },
    {
      key: "marketing",
      label: "Targeting Cookies",
      title: "Targeting Cookies",
      description:
        "These cookies support campaign measurement and relevant service updates. They help us understand which BlackRoth services visitors are interested in when optional cookies are allowed.",
      enabled: cookieSettings.marketing,
      settingKey: "marketing",
    },
  ];
  const selectedCookieCategory =
    cookiePreferenceCategories.find(
      (category) => category.key === activeCookieCategory
    ) || cookiePreferenceCategories[0];

  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            {/* ================= PUBLIC ROUTES ================= */}
            <Route element={<PublicLayout />}>
              <Route
                path="/"
                element={createSeoElement(homePageContent, pageSeo.home)}
              />

              <Route
                path="/contact-us"
                element={createSeoElement(homePageContent, pageSeo.contact)}
              />

              <Route path="/about" element={<Navigate to="/about-us" replace />} />
              <Route
                path="/about-us"
                element={createSeoElement(<AboutUs />, pageSeo.aboutUs)}
              />
              <Route
                path="/our-clients"
                element={createSeoElement(<OurClients />, pageSeo.ourClients)}
              />
              <Route
                path="/careers"
                element={createSeoElement(<CareersPage />, pageSeo.careers)}
              />
              <Route
                path="/careers/:jobId"
                element={createSeoElement(<JobDetailsPage />, pageSeo.careerDetails)}
              />
              {/* <Route path="/apply/:jobId" element={<ApplyPage />} /> */}

              <Route
                path="/newsroom"
                element={createSeoElement(<NewsroomPage />, pageSeo.newsroom)}
              />
              <Route
                path="/newsroom/blog"
                element={createSeoElement(<BlogPage />, pageSeo.blog)}
              />
              <Route
                path="/blog"
                element={<Navigate to="/newsroom/blog" replace />}
              />
              <Route
                path="/help"
                element={createSeoElement(<HelpCenterPage />, pageSeo.help)}
              />
              <Route
                path="/apidocs"
                element={createSeoElement(<ApiDocsPage />, pageSeo.apiDocs)}
              />
              <Route
                path="/privacy"
                element={createSeoElement(<PrivacyPolicyPage />, pageSeo.privacy)}
              />
              <Route
                path="/terms"
                element={createSeoElement(<TermsOfServicePage />, pageSeo.terms)}
              />
              <Route
                path="/security"
                element={createSeoElement(<SecurityPage />, pageSeo.security)}
              />
              <Route
                path="/fraud-alert"
                element={createSeoElement(<FraudAlertPage />, pageSeo.fraudAlert)}
              />
              <Route
                path="/raise-fraud-alert-ticket"
                element={createSeoElement(
                  <FraudAlertTicketPage />,
                  pageSeo.fraudTicket
                )}
              />
              <Route
                path="/validate-and-accept-offer"
                element={createSeoElement(
                  <ValidateOfferPage />,
                  pageSeo.validateOffer
                )}
              />
              <Route
                path="/letter-to-shareholders"
                element={createSeoElement(
                  <LetterToShareholdersPage />,
                  pageSeo.shareholders
                )}
              />
              <Route
                path="/letter-to-shareholders/:language"
                element={createSeoElement(
                  <LetterToShareholdersDetailPage />,
                  pageSeo.shareholderDetail
                )}
              />

              {/* Core service/detail pages */}
              <Route
                path="/research-and-development"
                element={createSeoElement(<RDPage />, pageSeo.rd)}
              />

              <Route
                path="/ui-ux-design-services"
                element={createSeoElement(<UIUXPage />, pageSeo.uiux)}
              />
              <Route
                path="/cloud-services"
                element={createSeoElement(
                  <CloudServicesPage />,
                  pageSeo.cloudServices
                )}
              />
              <Route
                path="/object-detection"
                element={createSeoElement(
                  <ObjectDetectionPage />,
                  pageSeo.objectDetection
                )}
              />
              <Route
                path="/autonomous-navigation"
                element={createSeoElement(
                  <AutonomousNavigationPage />,
                  pageSeo.autonomousNavigation
                )}
              />
              <Route
                path="/edge-computing"
                element={createSeoElement(
                  <EdgeComputingPage />,
                  pageSeo.edgeComputing
                )}
              />
              <Route
                path="/iot-integration"
                element={createSeoElement(
                  <IoTIntegrationPage />,
                  pageSeo.iotIntegration
                )}
              />

              {/* Services pages */}
              <Route
                path={SERVICE_ROUTES.index}
                element={createSeoElement(
                  <OurServicesIndex />,
                  pageSeo.ourServicesIndex
                )}
              />
              <Route
                path={SERVICE_ROUTES.hrIndex}
                element={createSeoElement(
                  <OurServicesIndex />,
                  pageSeo.hrServicesIndex
                )}
              />
              <Route
                path={SERVICE_ROUTES.payrollIndex}
                element={createSeoElement(
                  <OurServicesIndex />,
                  pageSeo.payrollIndex
                )}
              />
              <Route
                path={SERVICE_ROUTES.dataScienceAi}
                element={createSeoElement(<DataScienceAI />, pageSeo.dataScienceAI)}
              />
              <Route
                path={SERVICE_ROUTES.objectDetection}
                element={createSeoElement(
                  <ObjectDetection />,
                  pageSeo.objectDetectionService
                )}
              />
              <Route
                path={SERVICE_ROUTES.edgeComputing}
                element={createSeoElement(
                  <EdgeComputing />,
                  pageSeo.edgeComputingService
                )}
              />
              <Route
                path={SERVICE_ROUTES.iotIntegration}
                element={createSeoElement(
                  <IoTIntegration />,
                  pageSeo.iotIntegrationService
                )}
              />
              <Route
                path={SERVICE_ROUTES.cloudSecurity}
                element={createSeoElement(
                  <CloudSecurity />,
                  pageSeo.cloudSecurityService
                )}
              />
              <Route
                path={SERVICE_ROUTES.dataVisualization}
                element={createSeoElement(
                  <DataVisualization />,
                  pageSeo.dataVisualizationService
                )}
              />
              <Route
                path={SERVICE_ROUTES.uiUxDesign}
                element={createSeoElement(
                  <UIUXDesign />,
                  pageSeo.uiuxDesignService
                )}
              />
              <Route
                path={SERVICE_ROUTES.mobileDevelopment}
                element={createSeoElement(
                  <MobileDevelopment />,
                  pageSeo.mobileDevelopmentService
                )}
              />
              <Route
                path={SERVICE_ROUTES.aiMlServices}
                element={createSeoElement(
                  <AIMLServices />,
                  pageSeo.aimlServices
                )}
              />
              <Route
                path={SERVICE_ROUTES.dataScience}
                element={createSeoElement(
                  <DataScience />,
                  pageSeo.dataScienceService
                )}
              />

              {/* Learn more / solution page */}
              <Route
                path="/ai-solutions"
                element={createSeoElement(<AISolutions />, pageSeo.aiSolutions)}
              />

              {/* Payroll pages */}
              <Route
                path={SERVICE_ROUTES.payrollServices}
                element={createSeoElement(<PayrollPage />, pageSeo.payroll)}
              />
              <Route
                path={SERVICE_ROUTES.payrollProcessing}
                element={createSeoElement(
                  <PayrollProcessing />,
                  pageSeo.payrollProcessing
                )}
              />
              <Route
                path={SERVICE_ROUTES.payrollSoftware}
                element={createSeoElement(
                  <PayrollSoftware />,
                  pageSeo.payrollSoftware
                )}
              />

              {/* HR service pages */}
              <Route
                path={SERVICE_ROUTES.hrInsights}
                element={createSeoElement(
                  <HRInsightsPage />,
                  pageSeo.hrInsights
                )}
              />
              <Route
                path={SERVICE_ROUTES.hrServices}
                element={createSeoElement(
                  <HRServicesPage />,
                  pageSeo.hrServices
                )}
              />
              <Route
                path={SERVICE_ROUTES.partnerIntegration}
                element={createSeoElement(
                  <PartnerIntegrationPage />,
                  pageSeo.partnerIntegration
                )}
              />
              <Route
                path={SERVICE_ROUTES.bpoServices}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="BPOServices" />,
                  createServiceSeo(
                    "BPO Services | BlackRoth",
                    "Explore BlackRoth BPO services for scalable operational support, outsourcing delivery, and process efficiency.",
                    SERVICE_ROUTES.bpoServices,
                    "BPO Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.contentModeration}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="ContentModeration" />,
                  createServiceSeo(
                    "Content Moderation Services | BlackRoth",
                    "Discover BlackRoth content moderation services for safer platforms, policy enforcement, and brand protection.",
                    SERVICE_ROUTES.contentModeration,
                    "Content Moderation Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.customerSupport}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="CustomerSupport" />,
                  createServiceSeo(
                    "Customer Support Services | BlackRoth",
                    "Explore BlackRoth customer support services for responsive, multi-channel customer care and support operations.",
                    SERVICE_ROUTES.customerSupport,
                    "Customer Support Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.hrPayrollOperations}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="HRPayrollOperations" />,
                  createServiceSeo(
                    "HR & Payroll Operations | BlackRoth",
                    "Learn how BlackRoth supports HR and payroll operations with structured workflows, employee data management, and recurring operational support.",
                    SERVICE_ROUTES.hrPayrollOperations,
                    "HR & Payroll Operations"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.recruitmentProcessOutsourcing}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="RPO" />,
                  createServiceSeo(
                    "Recruitment Process Outsourcing | BlackRoth",
                    "Discover BlackRoth recruitment process outsourcing services for sourcing, screening, coordination, and hiring support.",
                    SERVICE_ROUTES.recruitmentProcessOutsourcing,
                    "Recruitment Process Outsourcing"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.backOfficeOperations}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="BackOfficeOperations" />,
                  createServiceSeo(
                    "Back Office Operations | BlackRoth",
                    "Explore BlackRoth back office operations services for streamlined administration, process tracking, and operational support.",
                    SERVICE_ROUTES.backOfficeOperations,
                    "Back Office Operations"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.dataEntryServices}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="DataEntryServices" />,
                  createServiceSeo(
                    "Data Entry Services | BlackRoth",
                    "See how BlackRoth data entry services help teams manage records, digitization, validation, and high-volume information workflows.",
                    SERVICE_ROUTES.dataEntryServices,
                    "Data Entry Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.technicalSupport}
                element={createSeoElement(
                  <HRServiceDetailPage serviceKey="TechnicalSupport" />,
                  createServiceSeo(
                    "Technical Support Services | BlackRoth",
                    "Explore BlackRoth technical support services for troubleshooting, helpdesk workflows, escalation support, and issue resolution.",
                    SERVICE_ROUTES.technicalSupport,
                    "Technical Support Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.healthIndex}
                element={createSeoElement(
                  <OurServicesIndex />,
                  createServiceSeo(
                    "Health Services | BlackRoth",
                    "Explore BlackRoth health services for medical coding, medical billing, revenue cycle management, claims management, and insurance eligibility verification.",
                    SERVICE_ROUTES.healthIndex,
                    "Health Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.medicalCoding}
                element={createSeoElement(
                  <HealthServicePage serviceKey="medicalCoding" />,
                  createServiceSeo(
                    "Medical Coding Services | BlackRoth",
                    "Explore BlackRoth medical coding services for accurate code assignment, coding audits, denial support, and compliant healthcare workflows.",
                    SERVICE_ROUTES.medicalCoding,
                    "Medical Coding Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.medicalBilling}
                element={createSeoElement(
                  <HealthServicePage serviceKey="medicalBilling" />,
                  createServiceSeo(
                    "Medical Billing Services | BlackRoth",
                    "Discover BlackRoth medical billing services for clean claim submission, payment posting, denial management, and revenue cycle support.",
                    SERVICE_ROUTES.medicalBilling,
                    "Medical Billing Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.revenueCycleManagement}
                element={createSeoElement(
                  <HealthServicePage serviceKey="revenueCycleManagement" />,
                  createServiceSeo(
                    "Revenue Cycle Management (RCM) Services | BlackRoth",
                    "Explore BlackRoth revenue cycle management services for patient registration, claims, payment posting, denial management, and improved healthcare cash flow.",
                    SERVICE_ROUTES.revenueCycleManagement,
                    "Revenue Cycle Management Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.claimsManagement}
                element={createSeoElement(
                  <HealthServicePage serviceKey="claimsManagement" />,
                  createServiceSeo(
                    "Healthcare Claims Management Services | BlackRoth",
                    "Explore BlackRoth claims management services for claim validation, status tracking, rejection correction, payer follow-up, and denial appeals.",
                    SERVICE_ROUTES.claimsManagement,
                    "Healthcare Claims Management Services"
                  )
                )}
              />
              <Route
                path={SERVICE_ROUTES.insuranceEligibilityVerification}
                element={createSeoElement(
                  <HealthServicePage serviceKey="insuranceEligibilityVerification" />,
                  createServiceSeo(
                    "Insurance Eligibility Verification Services | BlackRoth",
                    "Explore BlackRoth insurance eligibility verification services for active coverage, patient benefits, cost-sharing, referrals, and authorization checks.",
                    SERVICE_ROUTES.insuranceEligibilityVerification,
                    "Insurance Eligibility Verification Services"
                  )
                )}
              />
              <Route path="*" element={notFoundElement} />
            </Route>
            {/* ================= CANDIDATE PROTECTED ROUTES ================= */}
            <Route path="/layout/HRAdminLayout" element={<HRAdminLayout />} />
            <Route
              path="/components/Candidate/CandidateDashboard"
              element={
                <ProtectedRoute allowedRoles={["CANDIDATE"]}>
                  <CandidateDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/candidate/candidatecareer"
              element={
                <ProtectedRoute allowedRoles={["CANDIDATE"]}>
                  <Candidatecareer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/candidate/candidatecareer/:jobCode"
              element={<CandidateJobDetailsPage />}
            />
            <Route
              path="/candidate/candidatedashboard"
              element={
                <ProtectedRoute allowedRoles={["CANDIDATE"]}>
                  <CandidateDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Candidate/MyApplications"
              element={
                <ProtectedRoute allowedRoles={["CANDIDATE"]}>
                  <CandidateDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/apply/:jobId"
              element={
                <ProtectedRoute allowedRoles={["CANDIDATE"]}>
                  <ApplyPage />
                </ProtectedRoute>
              }
            />
            {/* ================= SUPER ADMIN ROUTES ================= */}
            <Route
              path="/components/Admins/AdminLayout"
              element={
                <ProtectedRoute allowedRoles={["SUPER_ADMIN"]}>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              {/* Default Dashboard
                <Route index element={<Dashboard />} /> */}

              {/* All Admin Pages */}
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="role-management" element={<RoleManagement />} />
              <Route path="blog-management" element={<BlogManagement />} />
              <Route path="blog-post" element={<BlogPost />} />
              <Route path="admin-images" element={<AdminImages />} />
              <Route path="job-management" element={<JobManagement />} />
              <Route path="all-posts" element={<AllPosts />} />
              <Route
                path="application-management"
                element={<ApplicationManagement />}
              />
              <Route
                path="interview-scheduling"
                element={<InterviewScheduling />}
              />
              <Route path="exporting-data" element={<ExportingData />} />
              <Route path="profile" element={<AdminProfile />} />
              <Route path="edit-info" element={<EditInfo />} />
              <Route path="password-change" element={<PasswordChange />} />
              <Route
                path="shareholder-letters"
                element={<ShareholderLettersManagement />}
              />
              <Route path="our-clients" element={<OurClientsManagement />} />
            </Route>
            {/* ================= HR ADMIN ROUTES ================= */}
            <Route
              path="/HRadmin/HRAdminLayout"
              element={
                <ProtectedRoute allowedRoles={["HR_ADMIN", "SUPER_ADMIN"]}>
                  <HRAdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<HRDashboardPage />} />
              <Route path="job-management" element={<HRJobManagementPage />} />
              <Route
                path="application-management"
                element={<HRApplicationManagementPage />}
              />
              <Route
                path="interview-scheduling"
                element={<HRInterviewSchedulingPage />}
              />
              <Route
                path="releasing-offer-letter"
                element={<HRReleasingOfferLetterPage />}
              />
              <Route
                path="upload-offer-letter"
                element={<HRUploadOfferLetterPage />}
              />
              <Route path="exporting-data" element={<HRExportingDataPage />} />
              <Route path="employee-details" element={<HREmployeeDetailsPage />} />
              <Route
                path="employee-credentials"
                element={<HREmployeeCredentialsPage />}
              />
              <Route path="bulk-emails" element={<HRBulkEmailsPage />} />
              <Route path="hr-profile" element={<HRProfilePage />} />
            </Route>
            <Route
              path="/ContentManager/ContentManagerLayout"
              element={
                <ProtectedRoute allowedRoles={["CONTENT_MANAGER"]}>
                  <ContentManagerLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<ContentManagerDashboard />} />
              <Route path="blogposts" element={<ContentManagerBlogPosts />} />
              <Route
                path="blogposts/create"
                element={<ContentManagerBlogForm />}
              />
              <Route
                path="blogposts/edit"
                element={<ContentManagerBlogForm />}
              />
              <Route
                path="blogposts/view/:id"
                element={<ContentManagerBlogDetails />}
              />
              <Route path="images" element={<ContentManagerImages />} />
              <Route path="*" element={<Navigate to="dashboard" replace />} />
            </Route>
          </Routes>
          <Chatbot />
          {showCookieNotice && (
            <section className="blackroth-cookie-notice" aria-label="Cookie notice">
              <div className="blackroth-cookie-content">
                <p>
                  We use cookies on our website to improve site
                  performance, personalize your experience, and understand how
                  visitors use our digital services. To learn more, please refer
                  to our{" "}
                  <a href="/privacy">Privacy Statement</a>
                  <button
                    className="blackroth-cookie-text-btn"
                    type="button"
                    onClick={() => {
                      setShowCookieClassification((current) => !current);
                      setShowCookieSettings(false);
                    }}
                  >
                    Cookie Classification
                  </button>
                </p>
                {showCookieClassification && (
                  <div className="blackroth-cookie-info-panel">
                    <div className="blackroth-cookie-settings-header">
                      <h3>Cookie Classification</h3>
                      <p>
                        BlackRoth groups cookies by purpose so you can understand
                        what each type supports before choosing your settings.
                      </p>
                    </div>
                    <div className="blackroth-cookie-classification-list">
                      <div className="blackroth-cookie-classification-item">
                        <strong>Essential</strong>
                        <span>
                          Keeps navigation, security, forms, and core website
                          features working.
                        </span>
                      </div>
                      <div className="blackroth-cookie-classification-item">
                        <strong>Analytics</strong>
                        <span>
                          Shows which pages are useful so we can improve content,
                          performance, and user journeys.
                        </span>
                      </div>
                      <div className="blackroth-cookie-classification-item">
                        <strong>Personalization</strong>
                        <span>
                          Helps remember visitor preferences and make BlackRoth
                          pages feel more relevant.
                        </span>
                      </div>
                      <div className="blackroth-cookie-classification-item">
                        <strong>Marketing</strong>
                        <span>
                          Supports campaign measurement and relevant service
                          updates when enabled.
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {showCookieSettings && (
                  <div className="blackroth-cookie-settings-panel">
                    <div className="blackroth-preference-header">
                      <strong>BlackRoth</strong>
                      <h3>Privacy Preference Centre</h3>
                      <button
                        className="blackroth-preference-close"
                        type="button"
                        aria-label="Close cookie settings"
                        onClick={() => setShowCookieSettings(false)}
                      >
                        x
                      </button>
                    </div>
                    <div className="blackroth-preference-body">
                      <div className="blackroth-preference-tabs">
                        {cookiePreferenceCategories.map((category) => (
                          <button
                            className={`blackroth-preference-tab${
                              activeCookieCategory === category.key
                                ? " active"
                                : ""
                            }`}
                            type="button"
                            key={category.key}
                            onClick={() => setActiveCookieCategory(category.key)}
                          >
                            {category.label}
                          </button>
                        ))}
                      </div>
                      <div className="blackroth-preference-detail">
                        <div className="blackroth-preference-detail-header">
                          <h4>{selectedCookieCategory.title}</h4>
                          {selectedCookieCategory.settingKey && (
                            <label className="blackroth-cookie-toggle">
                              <input
                                type="checkbox"
                                checked={selectedCookieCategory.enabled}
                                onChange={(event) =>
                                  setCookieSettings((current) => ({
                                    ...current,
                                    [selectedCookieCategory.settingKey]:
                                      event.target.checked,
                                  }))
                                }
                              />
                              <span>
                                {selectedCookieCategory.enabled ? "On" : "Off"}
                              </span>
                            </label>
                          )}
                          {selectedCookieCategory.locked &&
                            selectedCookieCategory.key === "essential" && (
                              <span className="blackroth-cookie-always-active">
                                Always Active
                              </span>
                            )}
                        </div>
                        <p>{selectedCookieCategory.description}</p>
                        {selectedCookieCategory.key === "privacy" && (
                          <a href="/privacy">Privacy Statement</a>
                        )}
                      </div>
                    </div>
                    <div className="blackroth-cookie-settings-actions">
                      <button
                        className="blackroth-cookie-settings-save"
                        type="button"
                        onClick={handleCookieSettingsSave}
                      >
                        Confirm My Choices
                      </button>
                      <button
                        className="blackroth-cookie-settings-secondary"
                        type="button"
                        onClick={() => handleCookiePreference("rejected")}
                      >
                        Reject All
                      </button>
                      <button
                        className="blackroth-cookie-settings-save"
                        type="button"
                        onClick={() => handleCookiePreference("accepted")}
                      >
                        Allow All
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="blackroth-cookie-actions">
                <button
                  className="blackroth-cookie-settings"
                  type="button"
                  onClick={() => {
                    setShowCookieSettings((current) => !current);
                    setShowCookieClassification(false);
                  }}
                >
                  Cookies Settings
                </button>
                <button
                  className="blackroth-cookie-action"
                  type="button"
                  onClick={() => handleCookiePreference("rejected")}
                >
                  Reject All
                </button>
                <button
                  className="blackroth-cookie-action"
                  type="button"
                  onClick={() => handleCookiePreference("accepted")}
                >
                  Accept All
                </button>
                <button
                  className="blackroth-cookie-close"
                  type="button"
                  aria-label="Close cookie notice"
                  onClick={() => handleCookiePreference("dismissed")}
                >
                  x
                </button>
              </div>
            </section>
          )}

        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;

 
